import { render, staticRenderFns } from "./ShipperForm.vue?vue&type=template&id=2b358389&scoped=true"
import script from "./ShipperForm.vue?vue&type=script&lang=js"
export * from "./ShipperForm.vue?vue&type=script&lang=js"
import style0 from "./ShipperForm.vue?vue&type=style&index=0&id=2b358389&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b358389",
  null
  
)

export default component.exports